
import React from 'react'
import { useNavigate } from 'react-router-dom';
import TableData from "../Partials/TableData3";

function ListWarehouse() {
  // This path is used to get All Warehouse 
  const path="getAllWarehouses/Datalist"
  const deletePath="deleteWareHouse" 
  const navigate=useNavigate()
 
    // const [par,setPar]=useState(props.par)
  const editClick=async(item)=> {
  navigate(`../addwarehouse/${item._id}`);
  }
  
  return (
   
    <React.Fragment>

    <div className="add-user-container">
      <div className='headingdiv'>
      
        <span className="componet-title">Warehouse List</span>
        <div>
        <button onClick={(()=>navigate(-1))}>Back</button>
        
        
        </div>
      </div>
      <div className="option-btn">
      <button onClick={()=>{navigate("../addwarehouse")}}>Add New Warehouse</button>
      <button onClick={()=>{navigate("../warehousestock")}}>Warehouse Stock</button>
       </div>
    
      <TableData path={path} deletePath={deletePath}  editClick={editClick}/>

    </div>
  </React.Fragment>
  
  )
}

export default ListWarehouse;